export default __webpack_public_path__ + "static/media/logo-powered.d4e5c480.svg";